import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { t } from "i18next";
import { AiOutlineInfo } from "react-icons/ai";
import { FaCheckCircle, FaRegCheckCircle } from "react-icons/fa";
import { FiCheck, FiX } from "react-icons/fi";
import { GiCancel } from "react-icons/gi";
import { BsInfoCircle } from "react-icons/bs";
import { BsExclamationCircle } from "react-icons/bs";
import { MdCancel } from "react-icons/md";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { RiErrorWarningLine, RiInformationFill } from "react-icons/ri";
import classNames from "classnames";
import { CiCircleCheck } from "react-icons/ci";

let TOAST_VERSION: "v1" | "v2" | "v3" = "v2";
export default class ToastUtils {
  static TYPE_ERROR(ERROR_MESSAGE_GET_MEMBERSHIP_LEVELS: any, TYPE_ERROR: any) {
    throw new Error("Method not implemented.");
  }

  static setToastVersion = (version: "v1" | "v2" | "v3") => {
    TOAST_VERSION = version;
  };

  static showSuccessToast = (msgOrHeading: string, subMsg?: string) => {
    const heading =
      TOAST_VERSION === `v1`
        ? subMsg
          ? msgOrHeading
          : t("toast.Success")
        : "";
    const subheading = subMsg || msgOrHeading;

    // const icon =
    //   TOAST_VERSION === `v1` ? (
    //     <div className="success-toast-icon-container">
    //       <span className="toast-icon">
    //         <FiCheck />
    //       </span>
    //     </div>
    //   ) : (
    //     <div
    //       className={classNames("success-toast-icon-container-v2", {
    //         "success-toast-icon-container-v2--success": true,
    //       })}
    //     >
    //       <FaCheckCircle style={{ flexShrink: 0 }} />
    //     </div>
    //   );

    // const toastClass =
    //   TOAST_VERSION === `v1`
    //     ? "custom-toast-success-container custom-toast-media-container"
    //     : "custom-toast-success-container-v2 custom-toast-media-container-v2";

    // toast.success(
    //   <ToastContent
    //     version={TOAST_VERSION}
    //     heading={heading}
    //     subheading={subheading}
    //     icon={icon}
    //   />,
    //   {
    //     position: TOAST_VERSION === `v1` ? "top-right" : "bottom-center",
    //     hideProgressBar: true,
    //     className: toastClass,
    //     toastId: "global-toast",
    //   }
    // );

    const icon =
      TOAST_VERSION === "v1" ? (
        <div className="success-toast-icon-container">
          <span className="toast-icon">
            <FiCheck />
          </span>
        </div>
      ) : TOAST_VERSION === "v3" ? (
        <div className="success-toast-icon-container-v3 success-toast-icon-container-v3--success">
          {/* <FaCheckCircle style={{ flexShrink: 0 }} /> */}
          <CiCircleCheck style={{ flexShrink: 0 }} />
        </div>
      ) : (
        <div className="success-toast-icon-container-v2 success-toast-icon-container-v2--success">
          <FaCheckCircle style={{ flexShrink: 0 }} />
        </div>
      );

    const toastClass =
      TOAST_VERSION === "v1"
        ? "custom-toast-success-container custom-toast-media-container"
        : TOAST_VERSION === "v3"
        ? "custom-toast-success-container-v3 custom-toast-media-container-v3"
        : "custom-toast-success-container-v2 custom-toast-media-container-v2";

    toast.success(
      <ToastContent
        version={TOAST_VERSION}
        heading={heading}
        subheading={subheading}
        icon={icon}
      />,
      {
        position: TOAST_VERSION === "v1" ? "top-right" : "bottom-center",
        hideProgressBar: true,
        className: toastClass,
        toastId: "global-toast",
      }
    );
  };

  static showErrorToast = (msgOrHeading: string, subMsg?: string) => {
    const heading =
      TOAST_VERSION === `v1` ? (subMsg ? msgOrHeading : t("toast.Error")) : "";
    const subheading = subMsg || msgOrHeading;

    // const toastClass =
    //   TOAST_VERSION === `v1`
    //     ? "custom-toast-error-container custom-toast-media-container"
    //     : "custom-toast-error-container-v2 custom-toast-media-container-v2";

    // const icon =
    //   TOAST_VERSION === `v1` ? (
    //     <div className="error-toast-icon-container">
    //       <span className="toast-icon">
    //         <FiX />
    //       </span>
    //     </div>
    //   ) : (
    //     <div
    //       className={classNames("error-toast-icon-container-v2", {
    //         "error-toast-icon-container-v2--error": true,
    //       })}
    //     >
    //       <MdCancel />
    //     </div>
    //   );

    // toast.error(
    //   <ToastContent
    //     version={TOAST_VERSION}
    //     heading={heading}
    //     subheading={subheading}
    //     icon={icon}
    //   />,
    //   {
    //     position: TOAST_VERSION === `v1` ? "top-right" : "bottom-center",
    //     hideProgressBar: true,
    //     className: toastClass,
    //     toastId: "global-toast",
    //   }
    // );

    const toastClass =
      TOAST_VERSION === "v1"
        ? "custom-toast-error-container custom-toast-media-container"
        : TOAST_VERSION === "v3"
        ? "custom-toast-error-container-v3 custom-toast-media-container-v3"
        : "custom-toast-error-container-v2 custom-toast-media-container-v2";

    const icon =
      TOAST_VERSION === "v1" ? (
        <div className="error-toast-icon-container">
          <span className="toast-icon">
            <FiX />
          </span>
        </div>
      ) : TOAST_VERSION === "v3" ? (
        <div className="error-toast-icon-container-v3 error-toast-icon-container-v3--error">
          <MdCancel />
        </div>
      ) : (
        <div className="error-toast-icon-container-v2 error-toast-icon-container-v2--error">
          <MdCancel />
        </div>
      );

    toast.error(
      <ToastContent
        version={TOAST_VERSION}
        heading={heading}
        subheading={subheading}
        icon={icon}
      />,
      {
        position: TOAST_VERSION === "v1" ? "top-right" : "bottom-center",
        hideProgressBar: true,
        className: toastClass,
        toastId: "global-toast",
      }
    );
  };

  static showInfoToast = (msgOrHeading: string, subMsg?: string) => {
    const heading =
      TOAST_VERSION === `v1` ? (subMsg ? msgOrHeading : t("toast.Info")) : "";
    const subheading = subMsg || msgOrHeading;

    // const toastClass =
    //   TOAST_VERSION === `v1`
    //     ? "custom-toast-info-container custom-toast-media-container"
    //     : "custom-toast-info-v2-container custom-toast-media-v2";

    // const icon =
    //   TOAST_VERSION === `v1` ? (
    //     <div className="info-toast-icon-container">
    //       <span className="toast-icon">
    //         <AiOutlineInfo />
    //       </span>
    //     </div>
    //   ) : (
    //     <div
    //       className={classNames("info-toast-icon-container-v2", {
    //         "info-toast-icon-container-v2--info": true,
    //       })}
    //     >
    //       <>
    //         {/* <BsInfoCircle /> */}
    //         {/* <IoIosInformationCircleOutline /> */}
    //         <RiInformationFill />
    //       </>
    //     </div>
    //   );

    // toast.info(
    //   <ToastContent
    //     version={TOAST_VERSION}
    //     heading={heading}
    //     subheading={subheading}
    //     icon={icon}
    //   />,
    //   {
    //     position: TOAST_VERSION === `v1` ? "top-right" : "bottom-center",
    //     hideProgressBar: true,
    //     className: toastClass,
    //     toastId: "global-toast",
    //   }
    // );

    const toastClass =
      TOAST_VERSION === "v1"
        ? "custom-toast-info-container custom-toast-media-container"
        : TOAST_VERSION === "v3"
        ? "custom-toast-info-container-v3 custom-toast-media-container-v3"
        : "custom-toast-info-v2-container custom-toast-media-v2";

    const icon =
      TOAST_VERSION === "v1" ? (
        <div className="info-toast-icon-container">
          <span className="toast-icon">
            <AiOutlineInfo />
          </span>
        </div>
      ) : TOAST_VERSION === "v3" ? (
        <div className="info-toast-icon-container-v3 info-toast-icon-container-v3--info">
          <RiInformationFill />
        </div>
      ) : (
        <div className="info-toast-icon-container-v2 info-toast-icon-container-v2--info">
          <RiInformationFill />
        </div>
      );

    toast.info(
      <ToastContent
        version={TOAST_VERSION}
        heading={heading}
        subheading={subheading}
        icon={icon}
      />,
      {
        position: TOAST_VERSION === "v1" ? "top-right" : "bottom-center",
        hideProgressBar: true,
        className: toastClass,
        toastId: "global-toast",
      }
    );
  };

  static showWarningToast = (msgOrHeading: string, subMsg?: string) => {
    const heading =
      TOAST_VERSION === `v1`
        ? subMsg
          ? msgOrHeading
          : t("toast.Warning")
        : "";
    const subheading = subMsg || msgOrHeading;

    // const toastClass =
    //   TOAST_VERSION === `v1`
    //     ? "custom-toast-warning-container custom-toast-media-container"
    //     : "custom-toast-warning-v2-container custom-toast-media-v2";

    // const icon =
    //   TOAST_VERSION === `v1` ? (
    //     <div className="warning-toast-icon-container">
    //       <span className="toast-icon">
    //         <AiOutlineInfo />
    //       </span>
    //     </div>
    //   ) : (
    //     <div
    //       className={classNames("warning-toast-icon-container-v2", {
    //         "warning-toast-icon-container-v2--warning": true,
    //       })}
    //     >
    //       <>
    //         {/* <BsExclamationCircle /> */}
    //         <RiErrorWarningLine />
    //       </>
    //     </div>
    //   );

    // toast.warning(
    //   <ToastContent
    //     version={TOAST_VERSION}
    //     heading={heading}
    //     subheading={subheading}
    //     icon={icon}
    //   />,
    //   {
    //     position: TOAST_VERSION === `v1` ? "top-right" : "bottom-center",
    //     hideProgressBar: true,
    //     className: toastClass,
    //     toastId: "global-toast",
    //   }
    // );

    const toastClass =
      TOAST_VERSION === "v1"
        ? "custom-toast-warning-container custom-toast-media-container"
        : TOAST_VERSION === "v3"
        ? "custom-toast-warning-container-v3 custom-toast-media-container-v3"
        : "custom-toast-warning-v2-container custom-toast-media-v2";

    const icon =
      TOAST_VERSION === "v1" ? (
        <div className="warning-toast-icon-container">
          <span className="toast-icon">
            <AiOutlineInfo />
          </span>
        </div>
      ) : TOAST_VERSION === "v3" ? (
        <div className="warning-toast-icon-container-v3 warning-toast-icon-container-v3--warning">
          <RiErrorWarningLine />
        </div>
      ) : (
        <div className="warning-toast-icon-container-v2 warning-toast-icon-container-v2--warning">
          <RiErrorWarningLine />
        </div>
      );

    toast.warning(
      <ToastContent
        version={TOAST_VERSION}
        heading={heading}
        subheading={subheading}
        icon={icon}
      />,
      {
        position: TOAST_VERSION === "v1" ? "top-right" : "bottom-center",
        hideProgressBar: true,
        className: toastClass,
        toastId: "global-toast",
      }
    );
  };
}

const ToastContent = ({
  version,
  heading,
  subheading,
  icon,
}: {
  version: string;
  heading: string;
  subheading?: string;
  icon: JSX.Element;
}) => (
  // <div
  //   className={
  //     version === "v1"
  //       ? "toast-content-container"
  //       : "toast-content-container-v2"
  //   }
  // >
  //   <div
  //     className={
  //       version === "v1" ? "toast-icon-container" : "toast-icon-container-v2"
  //     }
  //   >
  //     {icon}
  //   </div>
  //   <div>
  //     {heading && (
  //       <h4
  //         className={
  //           version === "v1"
  //             ? "custom-toast-heading"
  //             : "custom-toast-heading-v2"
  //         }
  //       >
  //         {heading}
  //       </h4>
  //     )}
  //     {subheading && (
  //       <p
  //         className={
  //           version === "v1" ? "custom-toast-body" : "custom-toast-body-v2"
  //         }
  //       >
  //         {subheading}
  //       </p>
  //     )}
  //   </div>
  // </div>

  <div
    className={
      version === "v1"
        ? "toast-content-container"
        : version === "v3"
        ? "toast-content-container-v3"
        : "toast-content-container-v2"
    }
  >
    <div
      className={
        version === "v1"
          ? "toast-icon-container"
          : version === "v3"
          ? "toast-icon-container-v3"
          : "toast-icon-container-v2"
      }
    >
      {icon}
    </div>
    <div>
      {heading && (
        <h4
          className={
            version === "v1"
              ? "custom-toast-heading"
              : version === "v3"
              ? "custom-toast-heading-v3"
              : "custom-toast-heading-v2"
          }
        >
          {heading}
        </h4>
      )}
      {subheading && (
        <p
          className={
            version === "v1"
              ? "custom-toast-body"
              : version === "v3"
              ? "custom-toast-body-v3"
              : "custom-toast-body-v2"
          }
        >
          {subheading}
        </p>
      )}
    </div>
  </div>
);
